// AI-CONTEXT: See docs/features/storytelling-document-upload.md
//
// Builds the StorytellingInterviews update written after the user reviews the
// redacted transcript. The transcript always lands in AudioTranscript — every
// downstream consumer (review gate, quote/anecdote analysis, mechanisms, TOC
// matches) keys off that field, regardless of whether the source was audio or
// a document.

/**
 * @param {object} args
 * @param {'audio' | 'document'} [args.mode] - Source of the interview (default audio)
 * @param {string} args.text - The reviewed, redacted transcript
 * @param {string[]} args.urls - Storage download URLs (audio chunks, or one document)
 * @param {object} args.summary - Counts-only PII summary from the privacy pipeline
 * @param {string} args.sessionId - Current session ID
 * @param {*} args.timestamp - Firestore server timestamp sentinel
 */
const buildInterviewUpdate = ({ mode = "audio", text, urls = [], summary = {}, sessionId, timestamp }) => {
    const update = {
        AudioTranscript: text,
        PIIRedacted: true,
        PIISummary: summary,
        ManuallyReviewed: true,
        ReviewedAt: timestamp,
        LastSessionID: sessionId,
        LastUpdated: timestamp,
    };

    if (mode === "document") {
        update.DocumentURL = urls[0] || "";
    } else {
        update.AudioURL = urls[0];
        update.AudioURLs = urls;
    }

    return update;
};

export default buildInterviewUpdate;
